export default __webpack_public_path__ + "static/media/token.f0637ca0.svg";